import React from 'react';
import { Nav, Card } from 'react-bootstrap';
import { ForumCategory } from '../../services/forumService'; // Import the type
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons'; // Example icon

interface ForumCategoryListProps {
  categories: ForumCategory[];
  selectedCategoryId: number | null; // ID of the currently selected category, or null for 'All Posts'
  onSelectCategory: (categoryId: number | null) => void; // Callback when a category is clicked
}

const ForumCategoryList: React.FC<ForumCategoryListProps> = ({ 
    categories, 
    selectedCategoryId, 
    onSelectCategory 
}) => {
  return (
    <Card className="border-0 shadow-sm">
      <Card.Body>
        <h6 className="text-muted mb-3">CATEGORIES</h6>
        <Nav variant="pills" className="flex-column">
          {/* All Posts Link */}
          <Nav.Item>
            <Nav.Link 
              href="#" // Prevent default anchor behavior
              active={selectedCategoryId === null} 
              onClick={(e) => { 
                  e.preventDefault(); 
                  onSelectCategory(null); 
              }}
              className="d-flex align-items-center mb-1" // Added flex for icon alignment
            >
              <FontAwesomeIcon icon={faGlobe} className="me-2 fa-fw" /> {/* Fixed width icon */}
              All Posts
            </Nav.Link>
          </Nav.Item>
          
          {/* Category Links */}
          {categories.map(category => (
            <Nav.Item key={category.id}>
              <Nav.Link 
                href="#" // Prevent default anchor behavior
                active={selectedCategoryId === category.id} 
                onClick={(e) => {
                    e.preventDefault();
                    onSelectCategory(category.id);
                }}
                className="d-flex align-items-center mb-1" // Added flex for icon alignment
                title={category.description || category.name} // Add description as tooltip
              >
                 {/* TODO: Add category-specific icons later? */}
                <span className="fa-li me-2 fa-fw"></span> {/* Placeholder for icon alignment */}
                {category.name}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Card.Body>
    </Card>
  );
};

export default ForumCategoryList; 